import { render, staticRenderFns } from "./admin_show_unit_button.vue?vue&type=template&id=45720e13&"
import script from "./admin_show_unit_button.vue?vue&type=script&lang=js&"
export * from "./admin_show_unit_button.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports